import type { PayexThunkAction } from 'store/configureStore';

import { featureFlags } from 'services/featureFlags/featureFlags';

import {
  ENABLE_FEATURE,
  FEATURES,
  FETCH_FEATURES_ERROR,
  FETCH_FEATURES_REQUEST,
  FETCH_FEATURES_SUCCESS,
} from '../../constants';

export const enableFeature = (feature: string) => ({
  type: ENABLE_FEATURE,
  payload: { [feature]: true },
});

export const fetchFeatures = (
  flags?: string | string[],
): PayexThunkAction<Promise<{ type: string; payload?: unknown }>> => {
  const flagsToFetch = flags
    ? Array.isArray(flags)
      ? flags
      : [flags]
    : FEATURES;

  return dispatch => {
    dispatch({ type: FETCH_FEATURES_REQUEST });

    return featureFlags
      .fetch(flagsToFetch)
      .then(payload => dispatch({ type: FETCH_FEATURES_SUCCESS, payload }))
      .catch(() => dispatch({ type: FETCH_FEATURES_ERROR }));
  };
};
